var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    className: "fill",
    d: "M14.04 19.206a1.492 1.492 0 01-1.512-1.483c0-.828.677-1.5 1.511-1.5.835 0 1.496.672 1.496 1.5 0 .827-.661 1.483-1.496 1.483zm13.489-1.655l-9.13-14.818c-.503-.734-1.07-1.39-1.762-1.89A4.337 4.337 0 0014.039 0c-1.007 0-1.857.312-2.612.843-.677.5-1.244 1.156-1.748 1.89L.503 17.629c-.693 1.421-.693 3.045.142 4.403C1.385 23.235 2.69 24 4.107 24h19.849c1.432 0 2.723-.765 3.462-1.968.835-1.342.866-3.091.11-4.48zm-13.49-2.81c-.55 0-.944-.453-1.007-1l-.504-4.481c-.078-.766.74-1.484 1.511-1.484.772 0 1.59.718 1.496 1.484l-.504 4.481c-.047.547-.44 1-.992 1z"
  })));
}
export default SvgWarning;